import { apiDownload } from "../../../lib/api/client";

export async function downloadMemberQuestionnaireCsv(versionId: string) {
  return apiDownload("/admin/exports/member-questionnaire.csv", {
    method: "POST",
    body: JSON.stringify({ versionId }),
  });
}
